
/* ============================================
   Email Signup Modal
   ============================================ 
(function () {
  'use strict';

  var overlay = document.getElementById('bs-modal-email-signup');
  if (!overlay) return;

  var closeBtn = overlay.querySelector('.bs-modal__close');

  function openModal() {
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function closeModal() {
    overlay.hidden = true;
    document.body.style.overflow = '';
  }

  // Triggers
  document.querySelectorAll('[data-bs-modal="email-signup"]').forEach(function (el) {
    el.addEventListener('click', openModal);
  });

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }

  // Click outside modal box
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });

  // Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) closeModal();
  });

})();
*/
(function () {
  'use strict';

  function openKlaviyoForm() {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'R2REhg']);
  }
  document.querySelectorAll('[data-bs-modal="email-signup"]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault(); // prevent links if any
      openKlaviyoForm();
    });
  });

})();